import { IPowerGroupParams, IResponseGetPowerGroup } from '~/utils/interface/powerGroup';
import axiosClient from './axiosClient';

const url: string = '/api/admin/power-group';

const powerGroupApi = {
  getList(params: IPowerGroupParams) {
    return axiosClient.get<IResponseGetPowerGroup>(url, { params });
  },
};
export default powerGroupApi;
